import { Component, ElementRef, OnInit, ChangeDetectorRef } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { element, browser } from 'protractor';
import { ConnectedUserComponent } from './shared/connectedUserComponent';
import { AuthenticationService } from './services/authentication.service';
import { TOKEN_NAME } from './services/auth.constant';
import { Router, NavigationEnd } from '@angular/router';
import { Modules } from './utils/enumeration';
import { Statique } from './utils/statique';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})

export class AppComponent extends ConnectedUserComponent implements OnInit {

	title = 'app';
	hideHeaderAndSideBar:boolean = false;
	module: number = null;
	Statique = Statique;

  	constructor(
	  	public translate: TranslateService,
	  	public router: Router,
	  	protected  authenticationService: AuthenticationService,
		private cdRef:ChangeDetectorRef
	) {
		super();
	}

	changerLangue(language: string) {
		this.translate.use(language);
	}

  // ngAfterViewChecked()
  // {
  //   this.Statique.hideSideBar = true;
  //   this.cdRef.detectChanges();
  // }

	ngOnInit() {
		let url = document.URL;

		this.router.events.subscribe((val) => {
			if (val instanceof NavigationEnd) {
				this.changeModule();
			}
		});
		this.translate.addLangs(["en", "fr"]);
		this.translate.setDefaultLang('fr');

		//browserLang = browserLang.match(/en|fr/) ? browserLang : 'en';

		if(this.userConnected == null){
			//this.router.navigate(['login']);
			return;
		}

     	let browserLang = this.translate.getBrowserLang();
	// 	if(this.userConnected.language){
	// 		this.changerLangue(this.userConnected.language);
	// 		console.log(this.userConnected.language)
	// 	}
	// 	else
	// 		this.changerLangue(browserLang);

		!(this.userConnected.language) ?
			window.localStorage.setItem("currentLang", browserLang) :
			window.localStorage.setItem("currentLang", this.userConnected.language);

		if (url.indexOf('inscription')>-1){
			this.hideHeaderAndSideBar = true;
		}

		if (url.indexOf('login')>-1){
			this.hideHeaderAndSideBar = true;
   		}

    	if (url.indexOf('reset-password')>-1){
			this.hideHeaderAndSideBar = true;
		}
		/*
		while(!this.userConnected || !this.userConnected.ebUserNum){
			await Statique.waitForTimemout(200);
		}*/
	}


	changeModule() {
		if (this.router.url.indexOf(Statique.moduleNamePath.PRICING) > -1) {
			this.module = Modules.PRICING;
		}
		else if (this.router.url.indexOf(Statique.moduleNamePath.TRANSPORT_MANAGEMENT) > -1) {
			this.module = Modules.TRANSPORT_MANAGEMENT;
		}
		else if (this.router.url.indexOf(Statique.moduleNamePath.TRACK) > -1) {
			this.module = Modules.TRACK;
		}
		else if (this.router.url.indexOf(Statique.moduleNamePath.FREIGHT_AUDIT) > -1) {
			this.module = Modules.FREIGHT_AUDIT;
		}
		else this.module = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts